const HEALTHY = 'HEALTHY';

export const icdCodeConstants = {
  HEALTHY,
};
